import type { EntityConfig } from '../types'

export const ecommerceEntity: EntityConfig = {
  id: 'ecommerce',
  displayName: 'Ecommerce',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'blocked', label: 'Blocked' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'blocked', label: 'Blocked', color: 'error' }
    ],
    mappings: {
      all: ['active', 'inactive', 'blocked'],
      active: ['active'],
      inactive: ['inactive'],
      blocked: ['blocked']
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    type: { type: 'string_array', urlKey: 'type' },
    createdDate: { type: 'date_range', urlKey: 'createdDate' },
    lastUsedDate: { type: 'date_range', urlKey: 'lastUsedDate' },
    blockedDate: { type: 'date_range', urlKey: 'blockedDate' },
    lastUpdatedDate: { type: 'date_range', urlKey: 'lastUpdatedDate' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'type',
    'createdDate',
    'lastUsedDate',
    'blockedDate',
    'lastUpdatedDate',
  ]
}
